module.exports = __webpack_public_path__ + "img/image-1.98f2830c.png";